<template>
    <section>
        <div class="ui basic segment">
            <a @click="$router.go(-1)" class="ui left basic button">
                <i class="reply icon"></i>Regresar
            </a>
            <h2 class="ui grey right floated header">
                <i class="edit icon"></i>
                Detalle de empresa dragón
            </h2>
        </div>

        <div class="ui grid">
            <div class="thirteen wide column">
                <sui-segment>
                    <div class="ui icon negative message" v-if="errors.length > 0">
                        <i class="exclamation triangle icon"></i>
                        <div class="content">
                            <div class="header">
                                Verifica los siguientes datos:
                            </div>
                            <ul>
                                <li v-for="error of errors" :key="error">{{error}}</li>
                            </ul>
                        </div>
                    </div>

                    <form class="ui form">
                        <h4 class="ui dividing blue header">Datos generales</h4>
                        <div class="field">
                            <div class="fields">
                                <div class="five wide required field" :class="{'error': !record.rfc }">
                                    <label>R.F.C.</label>
                                    <input type="text"
                                           placeholder="Escribe el R.F.C. de la empresa"
                                           v-model="record.rfc"
                                           @input="forceUpper($event, record, 'rfc')"
                                           @change="calculateFechaConstitucion()"
                                           v-if="!record.extranjera && !record.id">
                                    <strong class="ui blue header" v-else>{{ record.rfc }}</strong>
                                </div>
                                <div class="two wide field">
                                    <label>¿Es compañia extranjera?</label>
                                    <div v-if="record.editing && !record.id" class="ui toggle checkbox">
                                        <input type="checkbox" v-model="record.extranjera" @change="checkForeingCompany()" :disabled="record.id">
                                        <label></label>
                                    </div>
                                    <span v-else>{{ esExtranjeraStr }}</span>
                                </div>
                                <div class="three wide required field txtc">
                                    <label>Riesgo</label>
                                    <sui-dropdown
                                        v-if="record.editing && canEditMasterFields"
                                        fluid
                                        :options="Utils.displayOptions(FactoringCompanyRisks)"
                                        placeholder="Riesgo"
                                        selection
                                        v-model="record.riesgo"
                                    />
                                    <strong class="ui header" v-else>
                                        <i class="icon" :class="[Utils.getRiesgoInfo(record.riesgo).icon, Utils.getRiesgoInfo(record.riesgo).color]"></i>
                                        {{ Utils.getRiesgoInfo(record.riesgo).name || '' }}
                                    </strong>
                                </div>
                                <div class="three wide required field txtc">
                                    <label>Tipo</label>
                                    <sui-dropdown
                                        v-if="record.editing && canEditMasterFields"
                                        fluid
                                        :options="Utils.displayOptions(FactoringCompanyTypes)"
                                        placeholder="Tipo"
                                        selection
                                        v-model="record.tipo"
                                    />
                                    <strong class="ui header" v-else> {{ Utils.displayOptionName(FactoringCompanyTypes, record.tipo, '-') }} </strong>
                                </div>
                                <div class="three wide field txtc">
                                    <label>Estatus</label>
                                    <strong class="ui header">
                                        <i class="icon" :class="[Utils.getStatusInfo(record.statusId).icon, Utils.getStatusInfo(record.statusId).color]"></i>
                                        {{ Utils.getStatusInfo(record.statusId).name || '' }}
                                    </strong>
                                </div>
                            </div>
                        </div>
                        <div class="required field" :class="{'error': !record.razonSocial }">
                            <label>Razón Social</label>
                            <input type="text" placeholder="Escribe la razón social de la empresa" v-model="record.razonSocial" v-if="record.editing" @input="forceUpper($event, record, 'razonSocial')">
                            <span v-else> {{ record.razonSocial }} </span>
                        </div>
                        <div class="field">
                            <label>Nombre Comercial (Opcional)</label>
                            <input type="text" placeholder="Escribe el nombre comercial de la empresa" v-model="record.nombreComercial" v-if="record.editing" @input="forceUpper($event, record, 'nombreComercial')">
                            <span v-else> {{ record.nombreComercial }} </span>
                        </div>
                        <h4 class="ui dividing blue header">Datos especiales</h4>
                        <div class="fields">
                            <div class="required field" :class="{'error': !record.fechaConstitucion && !this.record.extranjera }">
                                <label>Fecha de constitución</label>
                                <v-date-picker
                                    v-if="record.editing"
                                    v-model="record.fechaConstitucion"
                                    :masks="masks">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ fechaConstitucionStr }}</span>
                            </div>
                        </div>
                        <div class="fields">
                                <div class="required six wide field" :class="{'error': !record.calle }">
                                    <label>Calle</label>
                                    <input type="text" placeholder="Calle" v-model="record.calle" v-if="record.editing" autocomplete="calle" @input="forceUpper($event, record, 'calle')">
                                    <span v-else> {{ record.calle }} </span>
                                </div>
                                <div class="required two wide field" :class="{'error': !record.numeroExterior }">
                                    <label>Número exterior</label>
                                    <input type="text" placeholder="Num. Exterior" v-model="record.numeroExterior" v-if="record.editing" autocomplete="numeroExterior" @input="forceUpper($event, record, 'numeroExterior')">
                                    <span v-else> {{ record.numeroExterior }} </span>
                                </div>
                                <div class="two wide field">
                                    <label>Número interior</label>
                                    <input type="text" placeholder="Num. Interior" v-model="record.numeroInterior" v-if="record.editing" autocomplete="numeroInterior" @input="forceUpper($event, record, 'numeroInterior')">
                                    <span v-else> {{ record.numeroInterior }} </span>
                                </div>
                                <div class="required two wide field" :class="{'error': !record.codigoPostal || invalidPostalCode }">
                                    <label>Código Postal</label>
                                    <input type="text" placeholder="Código Postal" v-model="record.codigoPostal" v-if="record.editing" @change="loadRegions()">
                                    <span v-else> {{ record.codigoPostal }} </span>
                                    <div v-if="invalidPostalCode" class="error-message">
                                        Código postal inválido
                                    </div>
                                </div>
                                <div class="required four wide field" :class="{'error': !record.colonia }">
                                    <label>Colonia</label>
                                    <ModelSelect :options="colonies"
                                        v-model="record.colonia"
                                        placeholder="Selecciona una colonia"
                                        :isDisabled="!record.editing"
                                        v-if="record.editing && !record.extranjera"/>
                                    <input type="text" placeholder="Escribe la colonia" v-model="record.colonia" v-else-if="record.editing && record.extranjera" @input="forceUpper($event, record, 'colonia')" >
                                    <span v-else> {{ displayColony(record.colonia) }} </span>
                                </div>
                        </div>
                        <div class="fields">
                            <div class="required four wide field" :class="{'error': !record.pais }">
                                <label for="new-add">País</label>
                                <ModelSelect :options="countriesOptions"
                                    v-model="record.pais"
                                    placeholder="Especifica el país"
                                    :isDisabled="!record.editing"
                                    @input="loadRegions"
                                    v-if="record.editing"/>
                                <span v-else> {{ record.pais }} {{ displayCountry(record.pais) }} </span>
                            </div>
                            <div class="required four wide field" :class="{'error': !record.estado }">
                                <label>Estado</label>
                                <ModelSelect :options="states"
                                    v-model="record.estado"
                                    placeholder="Selecciona un estado"
                                    :isDisabled="!record.editing"
                                    v-if="record.editing && !record.extranjera"/>
                                <input type="text" placeholder="Escribe el estado" v-model="record.estado" v-else-if="record.editing && record.extranjera">
                                <span v-else> {{ displayState(record.estado) }} </span>
                            </div>
                            <div class="required four wide field" :class="{'error': !record.municipio }">
                                <label>Municipio</label>
                                <ModelSelect :options="municipios"
                                    v-model="record.municipio"
                                    placeholder="Selecciona un estado"
                                    :isDisabled="!record.editing"
                                    v-if="record.editing && !record.extranjera"/>
                                <input type="text" placeholder="Escribe el municipio" v-model="record.municipio" v-else-if="record.editing && record.extranjera">
                                <span v-else> {{ displayLocation(record.municipio) }} </span>
                            </div>
                            <div class="required four wide field" :class="{'error': !record.ciudad }">
                                <label>Ciudad</label>
                                <ModelSelect :options="cities"
                                    v-model="record.ciudad"
                                    placeholder="Selecciona una ciudad"
                                    :isDisabled="!record.editing"
                                    v-if="record.editing && !record.extranjera"/>
                                    <input type="text" placeholder="Escribe la ciudad" v-model="record.ciudad" v-else-if="record.editing && record.extranjera">
                                    <span v-else> {{ displayCity(record.ciudad) }} </span>
                            </div>
                        </div>
                        <div class="fields">
                            <div class="required four wide field" :class="{'error': !record.email }">
                                <label>Email</label>
                                <input type="text" placeholder="Correo electrónico de contacto" v-model="record.email" v-if="record.editing" autocomplete="email" @input="forceLower($event, record, 'email')">
                                <span v-else> {{ record.email }} </span>
                            </div>
                            <div class="required four wide field" :class="{'error': !record.telefono }">
                                <label>Teléfono</label>
                                <input type="text" placeholder="Teléfono de contacto" v-model="record.telefono" v-if="record.editing">
                                <span v-else> {{ record.telefono }} </span>
                            </div>

                            <div class="four wide field">
                                <label>Teléfono 2  (Opcional)</label>
                                <input type="text" placeholder="Teléfono de contacto 2" v-model="record.telefonoSecundario" v-if="record.editing">
                                <span v-else> {{ record.telefonoSecundario }} </span>
                            </div>
                        </div>
                        <div class="required field" :class="{'error': !record.scianConcept }">
                            <label>Concepto SCIAN</label>
                            <ModelSelect
                                :options="scianCatalogOptions"
                                v-model="record.scianConcept"
                                autocomplete="off"
                                :isDisabled="!record.editing"
                                placeholder="Especifica el concepto SCIAN"
                                v-if="record.editing"/>
                            <span v-else> {{ record.scianConcept }} {{ displayScian }} </span>
                        </div>
                        <h4 class="ui dividing blue header">Apoderado Legal</h4>
                        <div class="fields">
                            <div class="four wide field">
                                <label>Primer Nombre</label>
                                <input type="text" placeholder="Escribe el primer nombre del apoderado legal" v-model="record.representative.firstName" v-if="record.editing" @input="forceUpper($event, record.representative, 'firstName')">
                                <span v-else> {{ record.representative.firstName }} </span>
                            </div>
                            <div class="four wide field">
                                <label>Segundo nombre</label>
                                <input type="text" placeholder="Escribe el segundo nombre del apoderado legal" v-model="record.representative.middleName" v-if="record.editing" @input="forceUpper($event, record.representative, 'middleName')">
                                <span v-else> {{ record.representative.middleName }} </span>
                            </div>
                            <div class="four wide field">
                                <label>Apellido Paterno</label>
                                <input type="text" placeholder="Escribe el apellido paterno del apoderado legal" v-model="record.representative.fatherSurname" v-if="record.editing" @input="forceUpper($event, record.representative, 'fatherSurname')">
                                <span v-else> {{ record.representative.fatherSurname }} </span>
                            </div>
                            <div class="four wide field">
                                <label>Apellido Materno</label>
                                <input type="text" placeholder="Escribe el nombre del apoderado legal" v-model="record.representative.motherSurname" v-if="record.editing" @input="forceUpper($event, record.representative, 'motherSurname')">
                                <span v-else> {{ record.representative.motherSurname }} </span>
                            </div>
                        </div>
                        <div class="fields">
                            <div class="four wide field">
                                <label>Nacionalidad</label>
                                <ModelSelect :options="countriesOptions"
                                        v-model="record.representative.nationality"
                                        placeholder="Nacionalidad del apoderado"
                                        :isDisabled="!record.editing"
                                        v-if="record.editing"/>
                                <span v-else> {{ record.representative.nationality }} {{ displayCountry(record.representative.nationality) }} </span>
                            </div>

                            <div class="four wide field">
                                <label>Tipo de forma migratoria</label>
                                <ModelSelect :options="migratoryFormTypeOptions"
                                        v-model="record.representative.typeMigration"
                                        placeholder="Selecciona un tipo"
                                        :isDisabled="!record.editing"
                                        v-if="record.editing"/>
                                <span v-else> {{ record.representative.typeMigration }} </span>
                            </div>

                            <div class="four wide field">
                                <label>No. de forma migratoria</label>
                                <input type="text" placeholder="Escribe el no. de forma migratoria del apoderado legal (opcional)" v-model="record.representative.noMigration" v-if="record.editing">
                                <span v-else> {{ record.representative.noMigration }} </span>
                            </div>
                        </div>
                        <div v-if="Utils.userHasPerm('can_approve_factoring_company')">
                            <h4 class="ui dividing blue header">¿A cuáles productos tiene acceso?</h4>
                            <div class="field">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" v-model="record.factorajeBlu" :disabled="!record.editing">
                                    <label>Factoraje American</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="ui toggle checkbox">
                                    <input type="checkbox" v-model="record.bluIndex" :disabled="!record.editing">
                                    <label>Blú Index</label>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <h4 class="ui dividing blue header">¿A cuáles productos tiene acceso?</h4>
                            <div class="field">
                                <i class="check circle accepted large icon" v-if="record.factorajeBlu"></i>
                                <i class="times circle rejected large icon" v-if="!record.factorajeBlu"></i>
                                Factoraje American
                            </div>
                            <div class="field">
                                <i class="check circle accepted large icon" v-if="record.bluIndex"></i>
                                <i class="times circle rejected large icon" v-if="!record.bluIndex"></i>
                                Blú Index
                            </div>
                        </div>
                    </form>
                </sui-segment>
            </div>

            <div class="three wide column">
                <sui-grid>
                    <sui-grid-row>
                        <sui-grid-column textAlign="center">
                            <img :src="images[record.tipo]" style="max-height: 100px;">
                            <div class="ui vertical fluid menu">
                                <div class="header header-menu">ACCIONES</div>
                                <div v-if="!dirtyTabs.length">
                                    <div class="link item" @click="editRecord()" v-if="!record.editing && record.id && !dirtyTabs.length">
                                        Editar
                                    </div>
                                    <div class="link item" @click="saveRecord()" v-if="record.editing && !dirtyTabs.length">
                                        Guardar
                                    </div>
                                    <div class="link item" @click="cancelEditRecord()" v-if="record.editing && !dirtyTabs.length">
                                        Cancelar
                                    </div>
                                    <div class="link item"
                                        v-if="record.statusId !== FactoringCompanyStatus.APPROVED && record.id && record.editing === false && !dirtyTabs.length"
                                        @click="approve()">
                                        Aprobar
                                    </div>
                                    <div class="link item"
                                        v-if="record.statusId !== FactoringCompanyStatus.REJECTED && record.id && record.editing === false && !dirtyTabs.length"
                                        @click="reject()">
                                        Rechazar
                                    </div>
                                    <div class="link item"
                                        v-if="record.statusId !== FactoringCompanyStatus.RESTRICTED && record.id && record.editing === false && !dirtyTabs.length"
                                        @click="restrict()">
                                        Restringir
                                    </div>
                                    <div class="link item"
                                        v-if="[FactoringCompanyStatus.PENDING, FactoringCompanyStatus.RESTRICTED].includes(record.statusId) && record.id && !record.editing && record.invoicesToReview.length > 0  && !dirtyTabs.length"
                                        @click="reviewInvoices()">
                                        Autorizar facturas
                                    </div>
                                    <div class="link item"
                                        v-if="record.id && record.editing === false && (record.invoices || []).length > 0  && !dirtyTabs.length"
                                        @click="openReviewedInvoices()">
                                        Historial de facturas autorizadas
                                    </div>
                                </div>
                            </div>
                        </sui-grid-column>
                    </sui-grid-row>
                </sui-grid>
            </div>
        </div>
        <br>
        <sui-tab :key="key" :menu="{ attached: true, tabular: true }" v-if="tabs.length > 0">
            <div v-for="tab in tabs" :key="tab.index">
                <sui-tab-pane :disabled="!!dirtyTabs.length && !dirtyTabs.includes(tab.index)"
                :title="tab.title"
                :icon="tab.icon"
                :label="[tab.label, dirtyTabs.includes(tab.index) && 'Cambios pendientes'].filter(_ => _).join(' — ')">
                    <component :ref="tab.component"
                        :is="tab.component"
                        :record.sync="record"
                        v-bind="tab.props"
                        :dirty="dirtyTabs.includes(tab.index)"
                        v-on:update:dirty="event =>  dirtyTabs = [...dirtyTabs.filter(_ => _ !== tab.index), ...(event ? [tab.index] : [])]"
                        :key="tab.index"
                        @loadRecord="processFunction(tab.loadRecordhandler || 'loadRecord', ...arguments)"
                    />
                </sui-tab-pane>
            </div>
        </sui-tab>

        <ReviewFactoringDocument :key="reviewModalKey" :showModal="showReviewModal" :company="record" :invoices="record.invoicesToReview" @modalResponse="saveReviews"/>
        <ReviewedInvoices :key="reviewedInvoicesKey" :showModal="showHistoryReviewModal" :company="record" @modalResponse="closeReviewesInvoices()"/>
    </section>
</template>

<script>

import FactoringCompanyService from '@/services/FactoringCompanyService'
import UserNotificationService from '@/services/UserNotificationService'
import FactoringDocumentReviewService from '@/services/FactoringDocumentReviewService'
import FactoringCompanyStatus from '@/common/FactoringCompanyStatus.js'
import ReviewFactoringDocument from '@/components/Modals/ReviewFactoringDocument.vue'
import ReviewedInvoices from '@/components/Modals/ReviewedInvoices.vue'
import Utils from '@/common/Utils.js'
import Vue from 'vue'
import moment from 'moment'
import ApiService from '@/services/ApiService'
import SepomexService from '@/services/SepomexService'
import ForeignRegionService from '@/services/ForeignRegionService'
import { ModelSelect } from 'vue-search-select'
import MigratoryFormType from '@/common/MigratoryFormType.js'
import FactoringCompanyTypes from '@/common/FactoringCompanyTypes.js'
import FactoringCompanyRisks from '@/common/FactoringCompanyRisks.js'
import Comments from '@/components/FactoringCompany/Tabs/Comments.vue'
import ClientFactoringCompany from '@/components/FactoringCompany/Tabs/ClientFactoringCompany.vue'
import eggImg from '@/assets/img/egg.png'
import dragonImg from '@/assets/img/dragon.jpg'

export default {
    name: 'FactoringCompanyDetail',

    components: { ReviewFactoringDocument, ReviewedInvoices, ModelSelect, Comments, ClientFactoringCompany },

    provide () {
        return {
            loadRecord: this.loadRecord
        }
    },

    data () {
        return {
            showReviewModal: false,
            showHistoryReviewModal: false,
            reviewModalKey: 0,
            reviewedInvoicesKey: 1000,
            FactoringCompanyStatus,
            FactoringCompanyTypes,
            FactoringCompanyRisks,
            Utils,
            errors: [],
            images: {
                [FactoringCompanyTypes.NO_DRAGON]: eggImg,
                [FactoringCompanyTypes.DRAGON]: dragonImg
            },
            record: this.getNewRecord(),
            scianCatalog: [],
            countries: [],
            states: [],
            cities: [],
            colonies: [],
            municipios: [],
            invalidPostalCode: false,
            migratoryFormTypeOptions: [
                {
                    value: MigratoryFormType.FMM,
                    text: 'Forma Migratoria Múltiple (FMM)'
                },
                {
                    value: MigratoryFormType.PERMANENT,
                    text: 'Residencia Permanente'
                },
                {
                    value: MigratoryFormType.TEMPORARY,
                    text: 'Residencia Temporal'
                }
            ],
            dirtyTabs: []
        }
    },

    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/logout')
        }
        if (!this.$route.params.id && !Utils.userHasPerm('can_add_factoring_company')) {
            this.$swal({
                title: 'No tienes permiso para realizar la acción',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Volver al listado',
                confirmButtonColor: '#2BBA45',
                showCloseButton: false
            }).then(async (result) => {
                let routeData = this.$router.resolve({ name: 'empresasDragon' })
                window.open(routeData.href, '_self')
            })
        }
        this.scianCatalog = await ApiService.getScianCatalog()
        this.scianCatalog.sort(function (a, b) { return a.scianDescription.localeCompare(b.scianDescription) })
        this.countries = await SepomexService.getCountries()
    },

    async mounted () {
        if (this.$route.params.id) {
            this.loadRecord(this.$route.params.id)
        }
    },

    filters: {
        upper (value) {
            return value.toUpperCase()
        }
    },

    computed: {
        // Permiso para editar tipo y riesgo
        canEditMasterFields () {
            return Utils.userHasPerm('can_edit_master_fields_factoring_company')
        },

        scianCatalogOptions () {
            if (this.scianCatalog) {
                return this.scianCatalog.map(item => {
                    return { value: item.scianCode, text: item.scianDescription }
                })
            }
            return []
        },

        displayScian () {
            if (this.record.scianConcept) {
                let concept = this.scianCatalog.find(item => item.scianCode === this.record.scianConcept)
                return concept ? concept.scianDescription : ''
            }
            return ''
        },

        countriesOptions () {
            if (this.countries) {
                return this.countries.map(item => {
                    return { value: item.id, text: item.countryName }
                })
            }
            return []
        },

        esExtranjeraStr () {
            return this.record.extranjera ? 'Sí' : 'No'
        },

        fechaConstitucionStr () {
            return this.record.fechaConstitucion && moment(this.record.fechaConstitucion).isValid() ? moment(this.record.fechaConstitucion).format('YYYY-MM-DD') : ''
        },

        tabs () {
            let localTabs = [
                {
                    index: 0,
                    title: 'Comentarios',
                    icon: 'list',
                    component: 'Comments',
                    props: {
                        'factoringCompany': this.record
                    }
                }, {
                    index: 1,
                    title: 'Relación con clientes',
                    icon: 'industry',
                    component: 'ClientFactoringCompany',
                    props: {
                        onDemand: true,
                        factoringCompany: this.record,
                        companyId: this.record.id
                    }
                }
            ]
            return localTabs
        }
    },

    watch: {
        '$route.params.id': {
            immediate: true,
            handler (newId) {
                if (newId) {
                    this.loadRecord(newId)
                } else {
                    this.record = this.getNewRecord()
                }
            }
        }
    },

    methods: {
        getNewRecord () {
            return {
                rfc: '',
                extranjera: false,
                pais: 'MEX',
                statusId: FactoringCompanyStatus.PENDING,
                razonSocial: '',
                nombreComercial: '',
                fechaConstitucion: undefined,
                calle: '',
                numeroExterior: '',
                numeroInterior: '',
                colonia: '',
                codigoPostal: '',
                estado: '',
                municipio: '',
                ciudad: '',
                telefonoSecundario: '',
                representativeId: '',
                representative: {
                    firstName: '',
                    middleName: '',
                    fatherSurname: '',
                    motherSurname: '',
                    nationality: '',
                    typeMigration: '',
                    noMigration: ''
                },
                factorajeBlu: false,
                bluIndex: false,
                comments: [],
                editing: true,
                invoices: [],
                invoicesToReview: [],
                risk: null,
                tipo: null
            }
        },

        displayCountry (countryCode) {
            if (countryCode) {
                let pais = this.countries.find(country => country.id === countryCode)
                return pais ? pais.countryName : ''
            }
            return ''
        },

        displayColony (colonyCode) {
            if (colonyCode) {
                let colonia = this.colonies.find(colony => colony.value === colonyCode)
                return colonia ? colonia.text : colonyCode
            }
            return colonyCode
        },

        displayState (stateCode) {
            if (stateCode) {
                let estado = this.states.find(state => state.value === stateCode)
                return estado ? estado.text : stateCode
            }
            return stateCode
        },

        displayLocation (locationCode) {
            if (locationCode) {
                let municipio = this.municipios.find(state => state.value === locationCode)
                return municipio ? municipio.text : locationCode
            }
            return locationCode
        },

        displayCity (cityCode) {
            if (cityCode) {
                let ciudad = this.cities.find(state => state.value === cityCode)
                return ciudad ? ciudad.text : cityCode
            }
            return this.record.ciudad
        },

        handleFocus (e) {
            e.target.setAttribute('autocomplete', null)
        },

        editRecord () {
            if (!Utils.userHasPerm('can_edit_factoring_company')) {
                this.$swal({
                    title: 'Error',
                    text: 'No tienes permiso para realizar la accion',
                    icon: 'error'
                })
                return
            }
            Vue.set(this.record, 'editing', true)
        },

        cancelEditRecord () {
            Vue.set(this.record, 'editing', false)
            this.errors = []
            if (this.$route.params.id) {
                this.loadRecord(this.$route.params.id)
            } else {
                let routeData = this.$router.resolve({ name: 'empresasDragon' })
                window.open(routeData.href, '_self')
            }
        },

        async loadRecord (id) {
            let loader = this.$loading.show()
            try {
                let { data } = await FactoringCompanyService.getOne(id, { withInvoices: true })
                Vue.set(this, 'record', data)
                Vue.set(this.record, 'editing', false)
                // this.record.invoicesToReview = this.record.invoices.filter(item => item.status === FactoringDocumentReviewStatus.PENDING)
                // this.record.invoicesToReview = this.record.invoicesToReview.map(item => {
                //     let invoice = Object.assign({}, item)
                //     invoice.newStatus = item.status
                //     return invoice
                // })
                loader.hide()
                if (!isNaN(Number(this.record.colonia))) {
                    this.record.colonia = Number(this.record.colonia)
                }
                this.loadRegions()
                if (!this.record.calle) {
                    this.record.calle = this.record.direccion
                }
                if (!isNaN(Number(this.record.estado))) {
                    this.record.estado = Number(this.record.estado)
                }
                if (!isNaN(Number(this.record.ciudad))) {
                    this.record.ciudad = Number(this.record.ciudad)
                }

                this.calculateFechaConstitucion()
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal({
                    title: 'La empresa no existe',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                }).then(async (result) => {
                    this.$router.push({ path: '/' })
                })
            }
        },

        validateData (action) {
            this.errors = []
            this.record.rfc = this.record.rfc.toUpperCase().trim()
            this.record.razonSocial = this.record.razonSocial.toUpperCase().trim()
            this.record.nombreComercial = this.record.nombreComercial.toUpperCase().trim()
            this.record.rfc = this.record.rfc.replace(/\s/g, '')
            if (!this.record.rfc) {
                this.errors.push('Indica el RFC')
            }
            if (this.record.rfc === 'XEXX010101000') {
                this.record.extranjera = true
                // this.errors.push('El RFC indicado sólo es valido para empresas extranjeras, marca la casilla')
            }
            if (this.record.rfc.length > 0 && (this.record.rfc.length !== 12 && this.record.rfc.length !== 13)) {
                this.errors.push('El RFC tiene longitud incorrecta (12 o 13 caracteres, y no debe contener espacios)')
            }

            if (action === 'approve' || action === 'restrict') {
                if (!this.record.tipo) {
                    this.errors.push('Indica el tipo')
                }
                if (!this.record.riesgo) {
                    this.errors.push('Indica el riesgo')
                }
                if (!this.record.factorajeBlu && !this.record.bluIndex) {
                    this.errors.push('La empresa debe tener al menos un producto asignado')
                }
            }

            if (!this.record.razonSocial) {
                this.errors.push('Indica la razón social')
            }
            // if (Utils.userHasPerm('can_approve_factoring_company')) {
            if (this.record.statusId === FactoringCompanyStatus.APPROVED) {
                if (!this.record.factorajeBlu && !this.record.bluIndex) {
                    this.errors.push('La empresa está aprobada, debe tener al menos un producto asignado')
                }
            }

            if ([FactoringCompanyStatus.APPROVED, FactoringCompanyStatus.RESTRICTED].includes(this.record.statusId) || action === 'approve' || action === 'restrict') {
                if (!this.record.fechaConstitucion && !this.record.extranjera) {
                    this.errors.push('Indica la fecha de constitución')
                }
                if (!this.record.calle) {
                    this.errors.push('Indica la calle')
                }
                if (!this.record.numeroExterior) {
                    this.errors.push('Indica el número exterior')
                }
                if (!this.record.codigoPostal) {
                    this.errors.push('Indica el código postal')
                }
                if (!this.record.colonia) {
                    this.errors.push('Indica la colonia')
                }
                if (!this.record.pais) {
                    this.errors.push('Indica el país')
                }
                if (!this.record.estado) {
                    this.errors.push('Indica el estado')
                }
                if (!this.record.municipio) {
                    this.errors.push('Indica el municipio')
                }
                if (!this.record.ciudad) {
                    this.errors.push('Indica la ciudad')
                }
                if (!this.record.email) {
                    this.errors.push('Indica el email')
                }
                if (!this.record.telefono) {
                    this.errors.push('Indica el teléfono')
                }
            }
        },

        async saveRecord (validate = true) {
            let loader = this.$loading.show()

            if (validate) await this.validateData()
            if (this.errors.length > 0) {
                loader.hide()
                return
            }
            if (this.record.pais === undefined) { this.record.pais = null }
            if (this.record.scianConcept === undefined) { this.record.scianConcept = null }
            if (this.record.telefono === undefined) { this.record.telefono = null }
            if (this.record.correo === undefined) { this.record.correo = null }
            delete this.record.invoices // Avoid large payloads

            if (this.record.id) {
                if (!this.canEditMasterFields) {
                    delete this.record.riesgo
                    delete this.record.tipo
                }
                try {
                    await FactoringCompanyService.update(this.record)
                    await this.loadRecord(this.record.id)
                    loader.hide()
                } catch (error) {
                    console.error(error)
                    loader.hide()
                    this.$swal('Error', 'Error al guardar empresa', 'error')
                }
            } else {
                try {
                    let { record } = await FactoringCompanyService.create(this.record)
                    loader.hide()
                    Vue.set(this.record, 'id', record.id)
                    Vue.set(this.record, 'editing', false)
                    this.$swal('Operacion exitosa', 'Se ha creado la empresa', 'success')
                    // this.$router.replace({ name: 'empresasDragonDetails', params: { id: record.id } })
                    this.$router.push({ name: 'empresasDragonDetails', params: { id: record.id } })
                    // let routeData = this.$router.resolve({ name: 'empresasDragonDetails', params: { id: this.record.id } })
                    // window.open(routeData.href, '_self')
                } catch (error) {
                    let msg = error.data.message || 'Error al crear empresa, contacta al administrador'
                    loader.hide()
                    this.$swal('Error', msg, 'error')
                }
            }
        },

        async approve () {
            if (!Utils.userHasPerm('can_approve_factoring_company')) {
                return this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
            }

            await this.validateData('approve')
            if (this.errors.length) return this.$swal('Error', 'Hay campos requeridos faltantes para poder aprobar la empresa', 'error')

            this.$swal({
                title: '¿Deseas aprobar la empresa?',
                html: 'Las facturas de este rfc serán aceptadas',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, aprobar',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showCloseButton: false
            }).then(async (result) => {
                if (result.value) {
                    let loader = this.$loading.show()
                    try {
                        await FactoringCompanyService.approve(this.record)
                        let request = { company: this.record, action: 'Empresa dragón aprobada' }
                        UserNotificationService.notifyOnCompanyUpdate(request)
                        loader.hide()
                        this.$swal('Operacion exitosa', 'Se ha aprobado la empresa', 'success')
                            .then(async () => { await this.loadRecord(this.record.id) })
                    } catch (error) {
                        console.error(error)
                        loader.hide()
                        let msg = error.data && error.data.message ? error.data.message : 'Error al aprobar empresa'
                        return this.$swal('Error', msg, 'error')
                    }
                }
            })
        },

        checkForeingCompany () {
            this.record.rfc = this.record.extranjera ? 'XEXX010101000' : null
            this.record.pais = this.record.extranjera ? '' : 'MX'
        },

        async reject () {
            if (!Utils.userHasPerm('can_reject_factoring_company')) {
                return this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
            }

            const result = await this.$swal({
                title: '¿Deseas rechazar la empresa?',
                html: 'Ninguna factura se aceptará',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, rechazar',
                confirmButtonColor: '#21ba45',
                cancelButtonText: 'No',
                cancelButtonColor: '#dc3741',
                allowEscapeKey: false,
                showCloseButton: false,
                allowOutsideClick: false,
                input: 'textarea',
                inputPlaceholder: '¿Tienes algún comentario adicional?',
                inputAttributes: {
                    'aria-label': '¿Tienes algún comentario adicional?'
                },
                customClass: {
                    input: 'swal-textarea-small'
                }
            })

            if (result.isConfirmed) {
                const record = { id: this.record.id, motive: result.value || '' }
                let loader = this.$loading.show()
                try {
                    await FactoringCompanyService.reject(record)
                    let request = { company: record, action: 'Empresa dragón Rechazada' }
                    UserNotificationService.notifyOnCompanyUpdate(request)
                    loader.hide()
                    this.$swal('Operacion exitosa', 'Se ha rechazado la empresa', 'success')
                        .then(async () => { await this.loadRecord(this.record.id) })
                } catch (error) {
                    console.error(error)
                    loader.hide()
                    let msg = error.data && error.data.message ? error.data.message : 'Error al rechazar empresa'
                    return this.$swal('Error', msg, 'error')
                }
            }
        },

        async restrict () {
            if (!Utils.userHasPerm('can_restrict_factoring_company')) {
                this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                return
            }
            await this.validateData('restrict')
            if (this.errors.length) return this.$swal('Error', 'Hay campos requeridos faltantes para poder restringir la empresa', 'error')

            const result = await this.$swal({
                title: '¿Deseas restringir la empresa?',
                html: 'Las facturas se aceptarán a discreción',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, restringir',
                confirmButtonColor: '#21ba45',
                cancelButtonText: 'No',
                cancelButtonColor: '#dc3741',
                allowEscapeKey: false,
                showCloseButton: false,
                allowOutsideClick: false,
                input: 'textarea',
                inputPlaceholder: '¿Tienes algún comentario adicional?',
                inputAttributes: {
                    'aria-label': '¿Tienes algún comentario adicional?'
                },
                customClass: {
                    input: 'swal-textarea-small'
                }
            })

            if (result.isConfirmed) {
                const record = { id: this.record.id, motive: result.value || '' }
                let loader = this.$loading.show()
                try {
                    await FactoringCompanyService.restrict(record)
                    let request = { company: record, action: 'Empresa dragón Restringida' }
                    UserNotificationService.notifyOnCompanyUpdate(request)
                    loader.hide()
                    this.$swal('Operacion exitosa', 'Se ha restringido la empresa', 'success')
                        .then(async () => { await this.loadRecord(this.record.id) })
                } catch (error) {
                    console.error(error)
                    loader.hide()
                    let msg = error.data && error.data.message ? error.data.message : 'Error al restringir empresa'
                    return this.$swal('Error', msg, 'error')
                }
            }
        },

        reviewInvoices () {
            if (!Utils.userHasPerm('can_authorize_invoices_of_dragons')) {
                this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                return
            }
            this.reviewModalKey += 1
            this.showReviewModal = true
        },

        async saveReviews (record) {
            if (record.cancel) {
                Vue.set(this, 'showReviewModal', false)
                return
            }
            let loader = this.$loading.show()
            Vue.set(this, 'showReviewModal', false)
            try {
                if (record.reviewedInvoices.length > 0) {
                    await FactoringDocumentReviewService.update({ invoices: record.reviewedInvoices })
                }
                await this.loadRecord(this.$route.params.id)
                loader.hide()
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal('Error', 'Error al guardar reviews', 'error')
            }
        },

        openReviewedInvoices () {
            this.reviewedInvoicesKey += 1
            this.showHistoryReviewModal = true
        },

        closeReviewesInvoices () {
            this.showHistoryReviewModal = false
        },

        forceUpper (e, obj, prop) {
            let newValue = obj[prop].toUpperCase()
            this.$set(obj, prop, newValue)
        },

        forceLower (e, obj, prop) {
            let newValue = obj[prop].toLowerCase()
            this.$set(obj, prop, newValue)
        },

        formatString (input) {
            if (typeof input !== 'string' || !input) return input
            return input.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },

        calculateFechaConstitucion () {
            if (!this.record.fechaConstitucion && this.record.rfc) {
                const vDay = this.record.rfc.substring(7, 9)
                const vMonth = this.record.rfc.substring(5, 7)
                const vYear = this.record.rfc.substring(3, 5)
                const currentYear = new Date().getFullYear()
                const fullYear = vYear > String(currentYear).substring(2, 4) ? `19${vYear}` : `20${vYear}`
                const vFullDate = new Date(Date.UTC(fullYear, vMonth - 1, vDay))
                const localDate = new Date(vFullDate.getTime() + vFullDate.getTimezoneOffset() * 60000)
                if (!isNaN(vFullDate)) {
                    this.record.fechaConstitucion = localDate
                }
            }
        },

        async loadRegions () {
            if (!this.record.codigoPostal) return
            if (this.record.extranjera) {
                if (!this.record.pais) return
                const { postalCodes } = await ForeignRegionService.postalCodeSearch({
                    postalcode: this.record.codigoPostal,
                    country: this.record.pais
                })
                if (postalCodes.length > 0) {
                    this.record.estado = postalCodes[0].adminName1
                    this.record.municipio = postalCodes[0].adminName2
                    this.record.ciudad = postalCodes[0].placeName || ''
                }
            } else {
                // OBTIENE LOS CATÁLOGOS
                const states = await SepomexService.getStates('MEX')
                const regions = await SepomexService.getColonies(this.record.codigoPostal)
                if (regions.length === 0) {
                    this.invalidPostalCode = true
                    return
                }
                this.invalidPostalCode = false
                const stateId = this.record.estado || await (async () => {
                    const result = await SepomexService.getStateIdByName(this.formatString(regions[0].estado))
                    if (Array.isArray(result) && result.length > 0) {
                        return result[0].id
                    }
                    return null
                })()
                const locations = await SepomexService.getLocations(stateId)
                const ciudades = await SepomexService.getCities(stateId)

                // CARGA LOS CATÁLOGOS
                this.colonies = regions.map(item => ({ value: item.id, text: item.nombre }))
                this.states = states.map(item => ({ value: item.id, text: item.stateName }))
                this.cities = ciudades.map(item => ({ value: item.id, text: item.nombre }))
                this.municipios = locations.map(item => ({ value: item.locationCode, text: item.nombre }))

                if (regions.length > 0) {
                    const state = states.find(item => item.id === stateId)
                    const location = locations.find(item => item.nombre === regions[0].municipio.toUpperCase())
                    let ciudad = {}
                    if (typeof this.record.ciudad === 'string' && this.record.ciudad !== '') {
                        ciudad = ciudades.find(item => item.nombre === this.formatString(this.record.ciudad)) || {}
                    } else if (!this.record.ciudad || this.record.ciudad === '') {
                        ciudad = ciudades.find(item => item.nombre === this.formatString(regions[0].ciudad)) || {}
                    }

                    this.record.pais = 'MEX'
                    this.record.estado = this.record.estado || state.id
                    this.record.municipio = this.record.municipio || location.nombre
                    this.record.ciudad = this.record.ciudad || (ciudad ? ciudad.id : null)
                }
            }
            this.$forceUpdate()
        }
    },

    created () {
        if (this.$route.params.id) this.loadRecord(this.$route.params.id)
    }
}
</script>
<style scoped>
    .header-menu {
        padding-top:5px;
        padding-bottom:5px;
        background-color: #1C1D1D;
        color: white;
        font-weight: bolder;
    }
    .item {
        margin-bottom: 5px;
    }
    .left-spaced {
        margin-left: 20px;
    }
    .accepted {
      color: green;
    }
    .rejected {
      color: red;
    }
    .txtc {
        text-align: center!important;
    }
</style>
